module.exports = __webpack_public_path__ + "static/media/info-gameinfo.56e487ca.png";